const HOME = {
  boostCampaignsTitle: 'Turbine e venda mais',
  yourOperationYesterday: 'Seu desempenho ontem',
  performance: 'Desempenho',
  trackYourIndicator:
    'Acompanhe seus indicadores de desempenho. As informações são referentes ao dia anterior:',
  availability: 'Disponibilidade',
  moreIndicators: 'mais indicadores',
  comparative: 'comparativo',
  moreInfo: 'mais informações',
  acceptanceRate: 'Aceitação',
  releaseRate: 'Liberação',
  trackingFee: 'Rastreio',
  customerRating: 'Avaliação',
  noDataForTheDay: 'Não há informações anteriores',
  indicators: 'Indicadores de ',
  tryAgainLater:
    'Não conseguimos recuperar os dados de ontem. Tente novamente mais tarde.',
  totalOrders: 'Total pedidos',
  totalSales: 'Total vendas',
  totalofOrders: 'Total de pedidos',
  totalofSales: 'Total de vendas',
  performanceIndicators: 'Indicadores de desempenho',
  comparedToYesterday: 'vs. ontem',
  acceptanceRateDescription:
    'Percentual de pedidos aceitos e válidos sobre o total de pedidos recebidos',
  availabilityDescription:
    'Percentual de funcionamento da loja conforme horário cadastrado',
  releaseRateDescription: 'Percentual dos pedidos liberados em até 10min',
  trackingFeeDescription: 'Percentual de pedidos corretamente rastreados',
  customerRatingDescription: 'Média da avaliação dos clientes',
  tooltip: {
    content:
      'Aqui você vai encontrar os valores referentes a sua perfomance durante os horários de operação da loja no dia anterior.',
    important:
      'Importante: se sua loja ficou fechada no dia anterior, não será exibido nenhum valor.',
    comparative:
      'O comparativo percentual de perfomance  é referente ao mesmo dia da semana anterior.',
  },
  noOrdersMessage: 'Você não teve pedidos ontem',
  shortcutSection: {
    title: 'Atalhos',
    cardsTitle: {
      orders: 'Pedidos Pendentes',
      markup: 'Markup',
      doubt: 'Dúvidas',
    },
  },
  io: {
    currency: 'R$',
    estimatedEarningPerOrder: 'ganho estimado por pedido',
  },
  ioCard: {
    title: 'Estimativa de Incentivo Operacional',
    incentiveExplanationText1:
      'O incentivo abaixo corresponde aos dias da semana',
    at: 'a',
    incentiveExplanationText2:
      'e pode variar de acordo com o total de pedidos, indicadores de desempenho e o horário da apuração dos indicadores. Por esse motivo, divergências podem acontecer',
    estimatedIncentiveText1: 'Seu incentivo seria de até',
    estimatedIncentiveText2:
      'se você melhorar os indicadores. Confira ao lado quais deles poderiam melhorar seu desempenho e aumentar seu incentivo.',
    estimatedIncentiveText2Mobile:
      'se você melhorar os indicadores. Confira abaixo quais deles poderiam melhorar seu desempenho e aumentar seu incentivo.',
    orders: 'Pedidos',
    multiply: 'X',
    iO: 'Incentivo',
    congratsText:
      'Uhul! Você atingiu seu melhor desempenho. Continue assim para manter seus indicadores de incentivo operacional positivos.',
    errorMessage:
      'Não conseguimos recuperar os dados do seu Incentivo Operacional no momento. Tente novamente mais tarde.',
    noOrdersMessage: 'Você ainda não teve pedidos essa semana',
  },
  kpisToImprove: {
    acessibilityKpiIcon: 'Ícone de',
    acessibilityAchievedPerformanceIcon: 'Ícone de atingimento de desempenho',
    youHaveAchievedPerformance: 'Oba! Você atingiu seu melhor desempenho!',
  },
  topDetractors: {
    topDetratactorsImg: 'imagem avaliações negativas',
    ideaImg: 'ícone de ideia',
    reasonsForNegativeReviewsMobile: 'Top razões de  avaliações ruins',
    reasonsForNegativeReviews: 'Razões das avaliações \n negativas',
    temperatureDissatisfaction: 'Insatisfação com a temperatura do pedido',
    tips: 'Dicas do Zé',
    noBadReviews:
      'Você não recebeu razões suficientes para serem categorizadas aqui',
    noOthersBadReviews: 'Eba! Você não tem outras razões de avaliações ruins',
    error: 'Ops, não conseguimos carregar esses dados agora. Tente mais tarde',
    tooltips: {
      button:
        'Dicas do time do Zé Delivery para ajudar a   melhorar suas avaliações',
      info: 'Essas são as principais razões das avaliações negativas  que você recebeu nos últimos 7 dias enviadas por pessoas que receberam pedidos da sua loja.',
    },
  },
}

export default HOME
